export default __webpack_public_path__ + "static/media/icon-sign-out.4caedaa5.svg";